// URL de la aplicación web "VCARS - GOOGLE SHEETS ENDPOINT" (Apps Script, termina en /exec).
// Recibe consultas, permutas y simulaciones de financiación y las guarda en "base de datos VCARS".
export const vcarsEndpoint = {
  scriptUrl: 'https://script.google.com/macros/s/AKfycbyGMe2b0Bfav8htr56bCj8nWKsiDAJs6lA08F6BT6S-THddyP1Dy0ZKebJ48Nqrm9MCZw/exec',
};
